import React from 'react';
import './LogoScreen.css';

function LogoScreen() {
  return (
    <div className="logo-screen">
      <div className="logo-content">
        <div className="logo-gif-container">
          <img 
            src="/fortuin.gif" 
            alt="Escape Room Logo" 
            className="logo-gif"
          />
        </div>
        <p className="subtitle">Escape Room Experience</p>
      </div>
    </div>
  );
}

export default LogoScreen;

